<template>
  <div>
    <!-- 新增按钮 -->

    <Input
      v-model="searchId"
      placeholder="输入用户ID"
      style="width: 200px; margin-right: 10px"
    />

    <Button type="primary" @click="queryGoods">查询</Button>
    <Button type="primary" @click="clickhedan">合单</Button>

    <Table :columns="columns10" :data="data9"> </Table>
    <div style="margin: 10px; overflow: hidden">
      <div style="float: right">
        <Page
          :total="total"
          :current="current"
          :page-size="50"
          @on-change="changePage"
        ></Page>
      </div>
    </div>

    <Modal
      v-model="couriernumModal"
      title="请填写快递单号"
      @on-ok="couriernumModalOk"
      @on-cancel="couriernumModal = false"
    >
      <Input
        v-model="couriernum"
        placeholder="请填写快递单号"
        style="width: 200px"
      />
    </Modal>
    <Modal
      v-model="returnModal"
      title="请选择退回原因"
      @on-ok="returnModalOk"
      @on-cancel="returnModal = false"
    >
      <Select v-model="selectedReturn" placeholder="请选择退回原因">
        <Option
          v-for="item in returnreason"
          :key="item.value"
          :value="item.value"
        >
          {{ item.label }}
        </Option>
      </Select>

      <Input
        v-if="isallreturn == false"
        v-model="returnnum"
        placeholder="请输入商品数量"
        :min="1"
        style="width: 200px"
        @on-input="validatePositiveInteger"
      />
    </Modal>
  </div>
</template>

<script>
const RETURN_REASONS = [
  { value: "碎片不足，无法发货", label: "碎片不足，无法发货" },
  {
    value: "地址不详，请联系客服提供地址",
    label: "地址不详，请联系客服提供地址",
  },
  { value: "请备注下礼品名称", label: "请备注下礼品名称" },
];
import SingleUpload from "@/components/Upload/singleUpload";
import {
  cmsSelShopOrder,
  cmsHebinOrder,
  cmsReturnOrder,
  cmsDeliverGoods,
} from "../../api/fahuo";
import expandRow from "./fahuolist_expand.vue";

export default {
  components: { expandRow, SingleUpload },
  data() {
    return {
      couriernumModal: false,
      couriernum: "",
      goodstypeOptions: this.$goodsTypeOptions,
      selectedRows: [], // 用于保存选中的行
      returnreason: RETURN_REASONS,
      returnModal: false,
      returnreasonIDs: [],
      selectedReturn: "",
      isallreturn: false,
      returnnum: "",
      loading: false,
      data9: [], // 用于存储查询结果
      columns10: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h(expandRow, {
              props: {
                row: params.row,
              },
              on: {
                triggerQueryGoods: this.queryGoods,
                triggerReturnOrder: (rowData) => {
                  console.log("rowData", rowData[0]);
                  if (rowData[0].goodsnum > 1) {
                    this.isallreturn = false;
                  } else {
                    this.isallreturn = true;
                  }
                  this.returnOrder(rowData); // 调用 returnOrder 方法并传递参数
                }, // 监听 expandRow 的事件，并调用 queryGoods
              },
            });
          },
        },
        {
          title: "合单",
          key: "action",
          width: 100,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h("Checkbox", {
                props: {
                  type: "primary",
                  size: "small",
                  value: this.selectedRows.includes(params.row), // 判断是否选中
                },
                style: {
                  marginRight: "5px",
                },
                on: {
                  "on-change": (isChecked) => {
                    console.log("change", isChecked);
                    // 如果选中，将该行加入数组，否则从数组中移除
                    if (isChecked) {
                      this.selectedRows.push(params.row);
                    } else {
                      this.selectedRows = this.selectedRows.filter(
                        (row) => row !== params.row
                      );
                    }
                  },
                },
              }),
            ]);
          },
        },

        {
          title: "订单号",
          key: "ordernum",
        },
        {
          title: "总成本",
          key: "cost",
        },
        {
          title: "商品数量",
          key: "goodsnum",
        },

        {
          title: "用户id",
          key: "user_id",
        },

        {
          title: "用户手机号",
          key: "user_phone",
        },
        {
          title: "用户地址",
          key: "user_address",
        },
        {
          title: "备注",
          key: "remarks",
        },
        {
          title: "申请时间",
          key: "createtime",
        },
        {
          title: "操作",
          key: "action",
          width: 250,
          align: "center",
          render: (h, params) => {
            // 判断逻辑：如果 params.row.rows 中的 procurestatus 都等于 1
            const allProcureStatusIsOne = params.row.rows.every(
              (row) => row.procurestatus === 1
            );

            return h("div", [
              // 根据判断结果渲染按钮
              allProcureStatusIsOne
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                      },
                      style: {
                        marginRight: "5px",
                      },
                      on: {
                        click: () => {
                          // 按钮的点击事件逻辑
                          this.fahuoOrder(params.row.rows);
                        },
                      },
                    },
                    "填写单号"
                  )
                : null, // 如果条件不满足，不显示按钮
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.isallreturn = true;
                      this.returnOrder(params.row.rows);
                    },
                  },
                },
                "退回整单"
              ),
            ]);
          },
        },
      ],
      searchId: "",
      searchName: "",
      searchType: "",
      current: 1,
      total: 0,
    };
  },

  mounted() {
    this.queryGoods();
  },
  methods: {
    couriernumModalOk() {
      if (!(this.couriernum && this.couriernum.length > 0)) {
        this.$Message.error("请输入快递单号");
        return;
      }
      cmsDeliverGoods({
        items: this.returnreasonIDs,
        couriernum: this.couriernum,
      }).then((res) => {
        this.queryGoods(); // 直接调用查询函数，不用重复逻辑
      });
    },
    fahuoOrder(data) {
      this.couriernumModal = true;
      var arr = [];
      for (let i = 0; i < data.length; i++) {
        arr.push(data[i]);
      }
      this.returnreasonIDs = arr;
    },
    validatePositiveInteger(value) {
      if (value < 1 || !Number.isInteger(+value)) {
        this.$Message.error("请输入一个正整数");
        this.returnnum = "";
      }
    },
    returnOrder(data) {
      console.log("data", data);
      this.returnModal = true;
      var arr = [];
      for (let i = 0; i < data.length; i++) {
        arr.push(data[i]);
      }
      this.returnreasonIDs = arr;
    },
    returnModalOk() {
      var rnum = 0;
      if (this.isallreturn == false) {
        rnum = parseInt(this.returnnum, 0);
        if (rnum > 0) {
          if (this.returnreasonIDs[0].goodsnum < rnum) {
            alert("退回数量不能大于订单商品数量");
            return;
          }
          if (this.returnreasonIDs[0].goodsnum == rnum) {
            rnum = 0;
          }
        } else {
          this.$Message.error("请输入一个正整数");
        }
      }
      cmsReturnOrder({
        items: this.returnreasonIDs,
        source: this.selectedReturn,
        rnum: rnum,
      }).then((res) => {
        this.queryGoods(); // 直接调用查询函数，不用重复逻辑
      });
    },

    clickhedan() {
      console.log(JSON.stringify(this.selectedRows)); // 输出所有选中的行

      // 获取第一个对象的值作为参照
      const firstRecord = this.selectedRows[0];
      const fields = [
        "orderid",
        "user_id",
        "user_phone",
        "user_address",
        "remarks",
      ];

      let isSame = true;

      // 遍历数组中的其他对象，检查对应字段是否相同
      for (let i = 1; i < this.selectedRows.length; i++) {
        for (let field of fields) {
          console.log(this.selectedRows[i][field], firstRecord[field]);
          if (this.selectedRows[i][field] !== firstRecord[field]) {
            isSame = false;
            console.log(
              `不匹配的字段: ${field}, 第 ${i} 条记录与第一条记录不同`
            );
            break;
          }
        }
      }

      var ids = [];
      var hebinid = this.selectedRows[0].rows[0].hebinid;
      for (var i = 0; i < this.selectedRows.length; i++) {
        for (var j = 0; j < this.selectedRows[i].rows.length; j++) {
          ids.push(this.selectedRows[i].rows[j].id);
        }
      }

      if (isSame) {
        console.log("hebinid=", hebinid);
        console.log("id=", ids);
        cmsHebinOrder({ ids: ids, hebinid: hebinid }).then((res) => {
          this.queryGoods(); // 直接调用查询函数，不用重复逻辑
        });
      } else {
        alert("有部分记录的字段不匹配。无法合单");
      }
    },
    // 查询商品
    // 公共查询函数
    fetchGoodsData(params = {}) {
      cmsSelShopOrder(params)
        .then((response) => {
          this.data9 = response.data.rows; // 获取查询结果
          this.current = response.data.pagination.page; // 获取当前页
          this.total = response.data.pagination.total; // 获取总数
        })
        .catch((error) => {
          console.error(error);
        });
    },

    // 查询商品
    queryGoods() {
      const params = {
        user_id: this.searchId || undefined,
        goodsname: this.searchName || undefined,
        goodstype: this.searchType || undefined,
        page: this.current,
      };
      this.fetchGoodsData(params);
    },

    // 分页查询
    changePage(e) {
      this.current = e;
      this.queryGoods(); // 直接调用查询函数，不用重复逻辑
    },
  },
};
</script>
